import { useCallback } from 'react';

import { downloadBase64PDF, printBase64PDF } from 'utils';

import { BaseDocument } from '../useOmniSignDocumentsFormBasePage';

interface OmniSignDocumentsFormBasePageActionBarHook {
  onDownloadClick: () => void;
  onPrintClick: () => void;
}

export default function useOmniSignDocumentsFormBasePageActionBar(
  document?: BaseDocument,
): OmniSignDocumentsFormBasePageActionBarHook {
  const onDownloadClick = useCallback(() => {
    if (!document) return;
    const { content, name } = document;
    downloadBase64PDF(content, name);
  }, [document]);

  const onPrintClick = useCallback(() => {
    if (!document) return;
    const { content, name } = document;
    printBase64PDF(content, name);
  }, [document]);

  return {
    onDownloadClick,
    onPrintClick,
  };
}
